import {appConfig, i18n} from 'src/shared/config'

import qrSrc from '../assets/qr-kaz.svg'

const prefix = appConfig.lang === 'ru' ? '/ru' : ''

export const legalLinks = [
  {
    label: i18n('order.footer.tariffs', 'Тарифы'),
    href: 'https://delivery.yandex.com/tariffs/kaz/',
  },
  {
    label: i18n('order.footer.user-agreement', 'Пользовательское соглашение'),
    href: `https://yandex.kz/legal/delivery_tou/?lang=${appConfig.lang}`,
    rel: 'noreferrer',
    target: '_blank',
  },
]

export const footerApp = {
  qr: qrSrc,
  buttons: {
    appStore:
      'https://8jxm.adj.st/route?tariffClass=express&ref=dostavka_web_badge&adj_t=ivdp40&adj_campaign=ALL-ALL-ALL&adj_adgroup=dostavka_web_badge&adj_deeplink=yandextaxi%3A%2F%2Froute%3FtariffClass%3Dexpress%26ref%3Ddostavka_web_badge',
    googlePlay: 'https://play.google.com/store/apps/details?id=ru.yandex.taxi',
    appGallery: 'https://appgallery.huawei.com/app/C101411413',
  },
}

export const footerLogo = {
  phrase1: i18n('order.footer.logo', 'Доставка в приложении'),
  phrase2: i18n(
    'order.footer.qr-instruction',
    'Наведите камеру на QR-код, чтобы скачать',
  ),
  invert: appConfig.lang === 'kk',
}

export const navLinks = [
  {
    label: i18n('order.header.link.express-delivery', 'Экспресс-доставка'),
    links: [
      {
        href: prefix + '/express-delivery/',
        label: i18n('order.header.link.express-delivery', 'Экспресс-доставка'),
      },
      {
        href: prefix + '/parcels/',
        label: i18n('order.header.link.parcels', 'Доставка отправлений'),
      },
    ],
  },
  {
    label: i18n('order.header.link.cargo-delivery', 'Грузовая доставка'),
    links: [
      {
        href: prefix + '/cargo/',
        label: i18n('order.header.link.cargo-delivery', 'Грузовая доставка'),
      },
      {
        href: prefix + '/cargo/taxi/',
        label: i18n('order.header.link.cargo-delivery.auto', 'Грузовое авто'),
      },
      {
        href: prefix + '/cargo/oversized/',
        label: i18n(
          'order.header.link.large-cargo',
          'Крупногабаритные отправления',
        ),
      },
    ],
  },
  {
    label: i18n('order.header.move', 'Перевозка'),
    links: [
      {
        href: prefix + '/move-things/',
        label: i18n('order.header.link.move-things', 'Перевозка вещей'),
      },
      {
        href: prefix + '/move-furniture/',
        label: i18n('order.header.link.move-furniture', 'Перевозка мебели'),
      },
    ],
  },
  {
    label: i18n(
      'order.footer.delivery-at-your-city',
      'Доставка в вашем городе',
    ),
    links: [
      {
        href: prefix + '/cargo/region/',
        label: i18n(
          'order.footer.link.cargo.region',
          'Грузовая доставка\nв вашем регионе',
        ),
      },
    ],
  },
  {
    label: i18n('order.footer.link.moves', 'Переезды'),
    links: [
      {
        href: prefix + '/move-flat/',
        label: i18n('order.header.link.move-flat', 'Квартирный переезд'),
      },
    ],
  },
]

export const footerLinks = [
  {
    label: i18n('order.become-a-client', 'Стать клиентом'),
    href: prefix + '/#reg-form',
  },
  {
    label: i18n(
      'order.footer.link.enter-to-personal-account',
      'Войти в личный кабинет',
    ),
    href: '/account/',
  },
  {
    label: i18n('order.footer.link.contact-support', 'Написать в поддержку'),
    href: 'mailto:help@dostavka.yandex.ru',
  },
  {
    href: prefix + '/tracking/',
    label: i18n('order.footer.link.track-delivery', 'Отследить доставку'),
  },
]
